import { useNavigate } from 'react-router-dom'
import { styled } from 'styled-components'
import { screen } from '../../styles/mq'

import { useLanguage } from 'languages/language'

const Anchor = styled.div`
  position: sticky;
  top: 0;
  height: 0;
  z-index: 3;
`

const Close = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
  width: 32px;
  height: 32px;
  font-size: 2.8rem;
  line-height: 1;
  justify-content: center;
  border-radius: 0 0 0 16px;
  border-right: none;
  border-top: none;
  background: transparent;
  border-left: none;
  border-bottom: none;
  @media (max-width: ${screen.m}) {
    background: var(--main);
    border-left: 2px solid var(--main);
    border-bottom: 2px solid var(--main);
  }
  color: var(--light);
  z-index: 2;
  cursor: pointer;
`

const FEATURED = [
  '/eriwen',
  '/voicesofthebrave',
  '/soldierswhodiedinukraine',
  '/ukraineweapons',
  '/ctcatalogue',
]

export const isProjectDetail = (pathname: string) =>
  FEATURED.includes(pathname) || /^\/(web|dalsi|zajmy)\/[^/]+$/.test(pathname)

export const CloseToProjects = () => {
  const navigate = useNavigate()
  const { lang } = useLanguage()

  return (
    <Anchor>
      <Close
        type="button"
        aria-label={lang === 'cz' ? 'Zpět na projekty' : 'Back to projects'}
        onClick={() => navigate('/projekty')}
      >
        ⨯
      </Close>
    </Anchor>
  )
}
